import CheckIcon from '@mui/icons-material/Check'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Fade from '@mui/material/Fade'
import FormControlLabel from '@mui/material/FormControlLabel'
import Menu from '@mui/material/Menu'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React, { useState } from 'react'

function SceltaLingua({
  lingua,
  cambiaLingua,
  selezionate,
  cambiaLingueSelezionate,
  confermaCopia,
  titolo = 'SCEGLI LA LINGUA',
}) {
  const [anchorCopia, setAnchorCopia] = useState(null)
  const openCopia = Boolean(anchorCopia)
  const hasCopiaFunctionality = selezionate && cambiaLingueSelezionate && confermaCopia

  return (
    <React.Fragment>
      <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap">
        {hasCopiaFunctionality ? (
          <h3 className="admin-titoletto">{titolo}</h3>
        ) : (
          <Typography sx={{ fontSize: 20, fontWeight: 'bold' }}>{titolo}</Typography>
        )}
        {hasCopiaFunctionality && (
          <>
            <Button
              size="small"
              variant={'outlined'}
              color={openCopia ? 'primary' : 'chiaro'}
              onClick={(event) => setAnchorCopia(event.currentTarget)}
            >
              COPIA
            </Button>
            <Menu
              id="fade-menu"
              MenuListProps={{ 'aria-labelledby': 'fade-button' }}
              anchorEl={anchorCopia}
              open={openCopia}
              onClose={() => setAnchorCopia(null)}
              TransitionComponent={Fade}
            >
              <Stack direction="column" width={200} paddingLeft={2} paddingRight={2}>
                {lingua != 1 && (
                  <FormControlLabel
                    control={<Checkbox checked={selezionate[0]} onChange={() => cambiaLingueSelezionate(0)} />}
                    label="Italiano"
                  />
                )}
                {lingua != 2 && (
                  <FormControlLabel
                    control={<Checkbox checked={selezionate[1]} onChange={() => cambiaLingueSelezionate(1)} />}
                    label="Inglese"
                  />
                )}
                {lingua != 3 && (
                  <FormControlLabel
                    control={<Checkbox checked={selezionate[2]} onChange={() => cambiaLingueSelezionate(2)} />}
                    label="Tedesco"
                  />
                )}
                {lingua != 4 && (
                  <FormControlLabel
                    control={<Checkbox checked={selezionate[3]} onChange={() => cambiaLingueSelezionate(3)} />}
                    label="Olandese"
                  />
                )}
                {lingua != 5 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selezionate.length > 4 ? selezionate[4] : false}
                        onChange={() => cambiaLingueSelezionate(4)}
                      />
                    }
                    label="Danese"
                  />
                )}
                {lingua != 6 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selezionate.length > 5 ? selezionate[5] : false}
                        onChange={() => cambiaLingueSelezionate(5)}
                      />
                    }
                    label="Polacco"
                  />
                )}
                <Stack direction="column" spacing={2} paddingTop={1} paddingBottom={1}>
                  <Button
                    size="small"
                    variant={'contained'}
                    color={'success'}
                    onClick={() => {
                      confermaCopia()
                      setAnchorCopia(null)
                    }}
                    startIcon={<CheckIcon />}
                  >
                    APPLICA
                  </Button>
                  <Button
                    size="small"
                    variant={'contained'}
                    color={'error'}
                    onClick={() => setAnchorCopia(null)}
                    startIcon={<HighlightOffIcon />}
                  >
                    ANNULLA
                  </Button>
                </Stack>
              </Stack>
            </Menu>
          </>
        )}
      </Stack>
      <RadioGroup row value={String(lingua)} onChange={(event) => cambiaLingua(parseInt(event.target.value))}>
        <FormControlLabel value="1" control={<Radio />} label="Italiano" />
        <FormControlLabel value="2" control={<Radio />} label="Inglese" />
        <FormControlLabel value="3" control={<Radio />} label="Tedesco" />
        <FormControlLabel value="4" control={<Radio />} label="Olandese" />
        <FormControlLabel value="5" control={<Radio />} label="Danese" />
        <FormControlLabel value="6" control={<Radio />} label="Polacco" />
      </RadioGroup>
    </React.Fragment>
  )
}

export default SceltaLingua
